import { ChangeDetectionStrategy, Component, effect, inject, Injector, input, ViewEncapsulation } from '@angular/core';
import { IOnboardingReportLocation } from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report';
import { FiInfiniteScrollDataSource, TSortOrder } from '@fi-shared/fi-items-list/fi-infinite-scroll-data-source';
import { FiItemsListType } from '@fi-shared/fi-items-list/fi-items-list-type';
import { ObjectTypes } from '@fi-shared/types';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiOnboardingStatusesConfig } from '@fi-app/fi-onboarding/fi-onboarding-consts';
import { FiOnboardingStatusType } from '@fi-app/fi-onboarding/fi-onboarding-enums';
import { FiOnboardingReportHelperService } from '@fi-app/fi-onboarding/fi-onboarding-report/services/fi-onboarding-report-helper.service';

@Component({
    selector: 'fi-onboarding-report-locations-widget-table',
    templateUrl: './fi-onboarding-report-locations-widget-table.component.html',
    styleUrl: './fi-onboarding-report-locations-widget-table.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-onboarding-report-locations-widget-table' },
    standalone: false,
})
export class FiOnboardingReportLocationsWidgetTableComponent extends FiInfiniteScrollDataSource<IOnboardingReportLocation> {
    public onboardingLocations = input.required<IOnboardingReportLocation[]>();
    public widgetId = input.required<number>();

    public readonly itemsListType = FiItemsListType.OnboardingReportLocations;
    public readonly objectType = ObjectTypes.OnboardingReport;
    //protected readonlydefaultSortColumnName = 'Status';

    protected readonly FiOnboardingStatusesConfig = FiOnboardingStatusesConfig;

    private readonly fiStateService = inject(FiStateService);
    private readonly fiOnboardingReportHelperService = inject(FiOnboardingReportHelperService);

    protected getRowClassFn = (item: IOnboardingReportLocation): string => 'cursor-pointer';

    constructor(injector: Injector) {
        super(injector);
    }

    private _onboardingLocationsChangeEffect = effect(() => {
        const onboardingLocations = this.onboardingLocations();
        const allItemsNotAvailable = !onboardingLocations.find(
            (item) => item.Status !== FiOnboardingStatusType.NotAvailable,
        );
        this.defaultSortColumnName = allItemsNotAvailable ? 'Name' : 'Status';
        const newSortData = this.getSortData(this.defaultSortColumnName, this.defaultSortDirection);
        this.updateCurrentSort(newSortData);
        this.reloadData();
    });

    public getListData(): Promise<IOnboardingReportLocation[]> {
        return Promise.resolve(this.onboardingLocations());
    }

    protected getSortOrderFn(): TSortOrder<IOnboardingReportLocation> {
        return this.fiOnboardingReportHelperService.getStatusSortOrderFn(
            this.selectedSort.active,
            this.isDescendingSort(),
            super.getSortOrderFn(),
        );
    }

    protected onRowClick(item: IOnboardingReportLocation) {
        this.fiStateService.go(FiStateNames.Onboarding.Report.Widget.Locations.Participants._name, {
            id: this.widgetId(),
            onboardingId: item.OnboardingId,
            businessUnitId: item.Id,
        });
    }

    protected isAvailable(item: IOnboardingReportLocation) {
        return item.Status !== FiOnboardingStatusType.NotAvailable;
    }
}
